import AppSettingsProvider from '%app/js/common/services/AppSettingsProvider';

const GOOGLE_ANALYTICS_TRACKING_ID = (new AppSettingsProvider()).getAppSettings().getGoogleAnalyticsTrackingId();

export {
    GOOGLE_ANALYTICS_TRACKING_ID,
};
